wizardSteps["appointment"] = {
    templateName: "#wizardStepAppointmentTemplate",
    allowAnonymous: true,
    onInit: function () {
        Handlebars.registerPartial('academyProList', Handlebars.compile($("#wizardStepAppointmentTemplate__academyProList").html()));
    },
    beforeRender: function (ctx) {
        ctx.model.o.__isAnOccObject = true;

        if (ctx.model.o && ctx.model.o.databaseTitle) {
            ctx.model.modalTitle = ctx.model.o.databaseTitle;
        } else {
            ctx.model.modalTitle = $t('Neuer Termin');
        }

        if (!currentEvent.hasOwnProperty('price')) {
            currentEvent.price = calendarConfiguration.hourlyFee;
        }

        ctx.model.appPrice = ctx.model.o.price = currentEvent.price;

        if (currentEvent.appointmentType !== "SingleTraining" && !currentEvent.price && calendarConfiguration.loginUserType !== "Me") {
            if (currentEvent.price || currentEvent.price === 0) {
                ctx.model.o.price = currentEvent.price;
            } else {
                ctx.model.o.price = currentEvent.price = calendarConfiguration.hourlyFee;
            }
        }

        ctx.model.o.__isApplianceOnly = calendarConfiguration.calendarType === "Appliances";

        // TODO Operator precedence probably is wrong
        ctx.model.showMarketingPageCheckbox = calendarConfiguration.loginUserType !== 'Me' &&
            calendarConfiguration.loginUserType !== 'Anonymous' &&
            currentEvent.appointmentType === 'MultiTraining' ||
            currentEvent.appointmentType === 'Package' ||
            currentEvent.appointmentType === 'Absence';

        if (currentEvent.occurences) {
            var currentOccurrence = currentEvent.occurences.filter(function (obj) {
                return obj.id === currentEvent.id;
            });

            if (currentOccurrence) {
                currentEvent.start = moment(currentOccurrence[0].startDate);
                currentEvent.end = moment(currentOccurrence[0].endDate);
            }
        }

        var paymentStatus = (ctx.model.o.participants
            && ctx.model.o.participants.length > 0
            && ctx.model.o.participants[0].paymentStatus !== "Unpaid"
            && ctx.model.o.participants[0].paymentStatus !== 'PaymentPendingStripe'
            && ctx.model.o.participants[0].paymentStatus !== 'PaymentPendingPrepaidCard')
            ? paymentStatusTranslations[ctx.model.o.participants[0].paymentStatus]
            : null;

        // paymentStatus { none, view, book } abhängig von o.isPublic und o.isNotBookable
        var view = !!ctx.model.o.isPublic;
        var book = view && !ctx.model.o.isNotBookable;
        var none = !view && !book;
        ctx.model.paymentStatus = {none: none, view: view, book: book};

        ctx.model.isBookedOut = ctx.model.o && ctx.model.o.isBookedOut;

        var displayName;
        if (calendarConfiguration.loginUserType === 'Golf Academy') {
            displayName = (currentResource && currentResource.internalId) ? currentResource.title : '';
        } else if (currentEvent.trainerId && calendarConfiguration.calendarType === "Courses") {
            var pro;
            for (var i = 0; i < academyProList.length; i++) {
                if (academyProList[i].id === currentEvent.trainerId) {
                    pro = academyProList[i];
                    break;
                }
            }
            if (pro) {
                displayName = pro.firstName + " " + pro.lastName;
            }
        }
        if (!displayName) {
            displayName = (calendarConfiguration.loginUserType === 'Pro'
                && currentEvent.appointmentType === "SingleTraining"
                && ctx.model.o.participants
                && ctx.model.o.participants.length)
                ? ctx.model.o.participants[0].firstName + " "
                + ctx.model.o.participants[0].lastName
                : calendarConfiguration.loginUserType === "Pro"
                && currentEvent.appointmentType !== "SingleTraining"
                    ? ''  // TODO: MAMP-396 Display Location Name
                    : calendarConfiguration.name;
        }

        if (currentEvent.location) {
            displayName += ((displayName && displayName !== '') ? ', ' : '') + currentEvent.location;
        }

        ctx.model.messages = {
            name: displayName,
            paymentStatus: $t(paymentStatus)
        };

        if (calendarConfiguration.loginUserType === 'Me' || calendarConfiguration.loginUserType === 'Anonymous') {
            ctx.model.paymentOptions = calendarConfiguration.paymentOptions || [];
            ctx.model.isMultiCard = !!currentMultiCard && currentEvent.appointmentType === "SingleTraining";

            if (currentEvent.isFlatrate || (currentMultiCard && currentEvent.appointmentType === "SingleTraining")) {
                // Clear all payment options for this occurrence, when it's a flatrate appointment.
                // We will query the API for a valid occurrence later.
                ctx.model.paymentOptions = [];
            }
        }

        // Meta information about the appointment
        ctx.model.m = {
            // For mes, template selection is only visible for new single training appointments
            showTemplateSelection: calendarConfiguration.calendarType !== "Appliances" && (currentEvent.appointmentType === "SingleTraining" || currentEvent.id),
            showAppointmentType: !(currentEvent.appointmentType === "SingleTraining")
        };

        if (currentEvent.id && currentEvent.templateId) {
            var trainerId = currentEvent.trainerId || calendarConfiguration.calendarOwnerId;
            if (!window.allProTemplates || !(trainerId in window.allProTemplates)) {
                if (!window.allProTemplates) {
                    window.allProTemplates = [];
                }
                window.allProTemplates[trainerId] = ApiClient.getAppointmentTemplates(trainerId, false).responseJSON;
            }

            var template = window.allProTemplates[trainerId].find(function (t) {
                return t.id === currentEvent.templateId;
            });
            if (template) {
                ctx.model.templateName = template.title;
            }
        }

        if (ctx.model.m.showAppointmentType) {

            ctx.model.messages.appointmentType = function () {

                switch (currentEvent.appointmentType) {
                    case 'MultiTraining':
                        return $t("Kurs / Event");
                    case 'Package':
                        return $t("Kurspaket");
                    case 'Absence':
                        return $t("Abwesenheit / Privat");
                    default:
                        return "";
                }
            };
        }

        ctx.model.messages.maximumParticipants = $t("Maximum participants");

        ctx.model.loginUserType = calendarConfiguration.loginUserType;
        ctx.model.canSetPrice = calendarConfiguration.loginUserType !== 'Me' && calendarConfiguration.loginUserType !== "Anonymous";
        if (!currentEvent.maxParticipants) {
            // Single trainings can only have one participant
            currentEvent.maxParticipants = currentEvent.appointmentType === "SingleTraining" ? 1 : 5;
        }
    },
    afterRender: function (ctx) {
        // Load templates if not yet present
        if (typeof (window.allProTemplates) !== "object") {
            window.allProTemplates = {};
        }

        var trainerId = currentEvent.trainerId || calendarConfiguration.calendarOwnerId;
        if (!(trainerId in window.allProTemplates)) {
            window.allProTemplates[trainerId] = ApiClient.getAppointmentTemplates(trainerId, false).responseJSON;
        }

        var options = window.allProTemplates[trainerId];
        window.calendarConfiguration.appointmentTypes = options; // Needed as a workaround for 100_helpers.js:GetAppointmentType
        var optionsHtml = "<option value=\"\" selected disabled>- " + $t('Bitte auswählen') + " -</option>";
        for (var i = 0; i < options.length; i++) {
            optionsHtml += "<option value=\"" + options[i].id + "\" " + "data-appo-price=\"" + options[i].price + "\">" + options[i].title + "</option>";
        }
        var templateDropdown = document.querySelector("#m-modal__appointment-type");
        if (templateDropdown) {
            templateDropdown.innerHTML = optionsHtml;
        }

        //#region max participants
        var $maxParticipantsField = $("#m-modal__input-participants-count");

        var updateMaxParticipantsFunction = function () {
            var maxParticipants = $maxParticipantsField.val();
            if (!maxParticipants) {
                maxParticipants = ctx.model.maxParticipants = 5;
            }
            ctx.model.maxParticipants = maxParticipants;
            $("#m-modal__step--package-headline").text(maxParticipants);
            currentEvent.maxParticipants = ctx.model.maxParticipants;
        };

        $maxParticipantsField.on("change", function () {
            updateMaxParticipantsFunction();
            wizardSteps["participants"].refreshParticipantWarning();
        });

        // Max participants input field
        $maxParticipantsField.on("change", function () {
            currentEvent.maxParticipants = parseInt($maxParticipantsField.val());
            if (isNaN(currentEvent.maxParticipants) || currentEvent.maxParticipants < 1) {
                currentEvent.maxParticipants = 1;
                maxParticipantsInputField.val(1);
            }
            wizardSteps["participants"].refreshParticipantWarning();
        });
        //#endregion

        var $priceOutputField = $("#m-modal__price-panel");
        var $typeSelection = $("#m-modal__appointment-type");
        var $subject = $("#m-modal__appointment-subject");
        var $titleField = $("#m-modal__input-appointment-title");
        var $descriptionField = $("#m-modal__textarea-appointment-description");
        var $coursePackDescriptionField = $("#m-modal__textarea-appointment-coursePack-description");
        var $datapicker = $(".m-modal__input.absence");
        var $timeStart = $("#time-start");
        var $timeEnd = $("#time-end");
        var $paymentRadioButton = $("input[name='paymentType']");
        var $primaryMenuBar = $(".m-modal__button-bar--primary");

        if ((calendarConfiguration.loginUserType === "Me" || calendarConfiguration.loginUserType === "Anonymous") && currentEvent.id) {
            $timeStart.prop("disabled", true);
            $timeEnd.prop("disabled", true);
        }

        if (currentEvent.templateId) {

            var $selectedType = $typeSelection.find('option[value=' + currentEvent.templateId + ']');

            if ($selectedType) {

                $selectedType.attr("selected", true);
            }

            if ((calendarConfiguration.loginUserType === "Me" || calendarConfiguration.loginUserType === "Anonymous") && ctx.model.o.id) {
                $typeSelection.prop("disabled", "disabled");
                $("#m-modal__appointment-type-label").html($t("Terminart") + ":");
            }
        }

        if (currentEvent.subjectId) {

            var $selectedSubject = $subject.find('option[value=' + currentEvent.subjectId + ']');

            if ($selectedSubject) {

                $selectedSubject.attr("selected", true);
            }
        }

        //#region price


        var updatePriceFunction = function () {

            var priceRaw = $('#m-modal__appointment-type option').filter(':selected').data('appo-price');
            if (priceRaw === undefined) {
                priceRaw = ctx.model.o.price;
            }
            var appointmentPrice = parseInt(priceRaw);

            if (!appointmentPrice) {
                appointmentPrice = 0;
            }
            if (!ctx.model.o.price) {
                ctx.model.o.price = 0;
            }
            ctx.model.o.price = appointmentPrice;
            currentEvent.price = ctx.model.o.price;

            // Price weirdness
            if (appointmentPrice === 0 && currentEvent.templateId) {
                var appoType = GetAppointmentType(currentEvent.templateId);
                if (appoType) {
                    price = appoType.price;
                }
            }

            if (!ctx.model.o.appliance) return;
            var total = $("#m-modal__price-total");
            if (total.length !== 1) return;
            //if (ctx.model.o.appliance.priceTotal !== 0) return; // Room calendar, calculated later
            if (ctx.model.o.priceTrainer !== null && ctx.model.o.priceTrainer !== undefined) {
                appointmentPrice += ctx.model.o.priceTrainer;
            } else {
                appointmentPrice += ctx.model.o.appliance.priceTotal;
            }
            if (calendarConfiguration.currencySymbol === "$") {
                total.text("$ " + appointmentPrice);
            } else {
                total.text(appointmentPrice + "€");
            }
            console.log("Total: " + appointmentPrice);
        };

        $typeSelection.on('change', updatePriceFunction);

        $priceOutputField.on("change", updatePriceFunction);
        updatePriceFunction();
        window.updatePriceFunction = updatePriceFunction;
        //#endregion price

        // Absence only
        var $dateStart, $dateEnd;
        var isAbsence = false;
        if (currentEvent.appointmentType === "Absence") {
            isAbsence = true;
            $dateStart = $("input[name='dateFrom']");
            $dateEnd = $("input[name='dateTo']");

            if (!currentEvent.end) {
                currentEvent.end = currentEvent.start.clone().add(calendarConfiguration.calendarRaster, "minutes");
            }
        }

        var $validationError = ctx.$el.find(".m-modal__validation-error.startEndTime");

        var performValidation = function () {
            var isValid = true;
            if (isAbsence) {
                if ($dateStart.val() > $dateEnd.val()) {
                    isValid = false;
                }
            }

            if (isValid) {
                if ($timeStart.val()) {
                    var startMinutes = $timeStart.find('option:selected').val().split(":");
                    startMinutes = parseInt(startMinutes[0]) * 60 + parseInt(startMinutes[1]);
                }
                if ($timeEnd.val()) {
                    var endMinutes = $timeEnd.find('option:selected').val().split(":");
                    endMinutes = parseInt(endMinutes[0]) * 60 + parseInt(endMinutes[1]);
                }
                if (startMinutes && endMinutes) {
                    isValid = (startMinutes < endMinutes);
                }
            }

            if (isValid) {
                $validationError.hide();
            } else {
                $validationError.show();
            }
        };
        var updateFunction = function (allowEndOverride, allowPriceOverride) {
            // Check for groups.
            if (allowEndOverride) {
                // Disable options not belonging to the group of the currently selected start time.
                var $selectedOption = $timeStart.find('option:selected');
                var groupId = $selectedOption.attr('data-group');
                if (groupId) {
                    $timeEnd.find('option[data-group="' + groupId + '"]').prop('disabled', false);
                    $timeEnd.find('option:not([data-group="' + groupId + '"])').prop('disabled', true);
                }

                // Select the corresponding end time when the currently selected end time is no longer available.
                var $selectedEndTime = $timeEnd.find('option:selected');
                if ($selectedEndTime.is(':disabled')) {
                    var idx = $timeStart.prop('selectedIndex');
                    $timeEnd.prop('selectedIndex', idx);
                }

                setTimeout(function () {
                    currentEvent.end2 = moment(currentEvent.start.format('YYYY-MM-DD') + "T" + $timeEnd.val()); // end not defined yet
                }, 100);
            }

            var $appointmentType;
            if (calendarConfiguration.calendarType === "Appliances") {

                // Do not perform price for existing appointments
                if (currentEvent.id) {
                    return;
                }

                // Create fake appointment type for the below functionality
                $appointmentType = {
                    units: currentEvent.appliance.units || 1,
                    price: calendarConfiguration.currentAppliance.price
                };
            } else {
                if ($typeSelection.length === 0 || $typeSelection.val() === null) {
                    // Selection not present, skip
                    performValidation();
                    return;
                }
                $appointmentType = GetAppointmentType($typeSelection.val());
                if (!$appointmentType) {
                    // Type not found, ignore
                    performValidation();
                    return;
                }
            }

            // Update end time, if allowed
            if (allowEndOverride && !isAbsence) {
                var size = $timeEnd.children().length;
                var selectedStartIndex = $timeStart.find(":selected").data("index");
                if (selectedStartIndex === -1) {
                    console.error("Could not update start time: Could not calculate current start time");
                }

                // We need to subtract 1 here, because the endtime starts 1 timeslot after the starttime.
                var targetEndIndex = selectedStartIndex + $appointmentType.units - 1;
                if (targetEndIndex <= size - 1) {
                    $timeEnd.children().eq(targetEndIndex).prop('selected', true);
                } else {
                    $timeEnd.children().last().prop('selected', true);
                }
            }

            // Update price field, if allowed
            if (allowPriceOverride && !isAbsence) {
                if (calendarConfiguration.calendarType === "Appliances") {
                    // Order of operations warning here: We need to re-calculate the price
                    // because the above code block might have changed the appointment's duration

                    var startMinutes = $timeStart.find('option:selected').val().split(":");
                    startMinutes = parseInt(startMinutes[0]) * 60 + parseInt(startMinutes[1]);
                    var endMinutes = $timeEnd.find('option:selected').val().split(":");
                    endMinutes = parseInt(endMinutes[0]) * 60 + parseInt(endMinutes[1]);

                    var units = (endMinutes - startMinutes) / calendarConfiguration.currentAppliance.raster;
                    var price = calendarConfiguration.currentAppliance.price * units;

                    $appointmentType.units = units;
                    $appointmentType.price = price;
                    // Write back units because the $appointmentType will be overridden on every call to this function
                    currentEvent.appliance.units = units;

                    // Shitty price formatting
                    if (calendarConfiguration.currentAppliance.priceFormatted.indexOf(calendarConfiguration.currencySymbol) === 0) {
                        $appointmentType.priceFormatted = calendarConfiguration.currencySymbol + " " + price;
                    } else {
                        $appointmentType.priceFormatted = price + " " + calendarConfiguration.currencySymbol;
                    }

                    var total = $("#m-modal__price-total");
                    if (total.length !== 1) return;
                    total.text($appointmentType.priceFormatted);
                }

                currentEvent.price = $appointmentType.price;
                if ($priceOutputField.is("input")) {
                    $priceOutputField.val($appointmentType.price);
                } else {
                    var priceString = $appointmentType.priceFormatted;

                    if (currentEvent.appliance && currentEvent.appliance.priceFormatted && calendarConfiguration.calendarType !== "Appliances") {
                        priceString += " + " + currentEvent.appliance.priceTotalFormatted;
                    }

                    $priceOutputField.text(priceString);
                }
            }

            if (calendarConfiguration.loginUserType === 'Pro' && currentEvent.appointmentType === 'SingleTraining') {
                var units = $timeEnd.prop('selectedIndex') - $timeStart.prop('selectedIndex') + 1;
                if (units > 0) {
                    var pricePerUnit = $appointmentType.price / $appointmentType.units;
                    $priceOutputField.val(($appointmentType.units * pricePerUnit).toFixed(2));
                }
            }

            // Perform validation
            performValidation();
        };

        if (currentEvent.appliance) {
            // Force update of price after returning from appliance step, otherwise it's just blank
            updateFunction(false, true);
        }

        $timeStart.on("change", function () {
            // When changing the start time, we want to adjust the end accordingly
            updateFunction(true, calendarConfiguration.calendarType === "Appliances");
        });

        $timeEnd.on("change", function () {
            // When changing the end time, we don't want to change anything
            updateFunction(false, calendarConfiguration.calendarType === "Appliances");
        });

        var selectCurrentTime = function () {
            $timeStart.val(currentEvent.start.format("HH:mm"));
            $timeStart.trigger('change');
            if (currentEvent.end) {
                $timeEnd.val(currentEvent.end.format("HH:mm"));
                $timeEnd.trigger('change');
            } else {
                var selectedStartIndex = $timeStart.find(":selected").data("index");
                if (selectedStartIndex === -1) {
                    console.error("Could not update start time: Could not calculate current start time");
                }
                var size = $timeEnd.children().length;
                var targetEndIndex = selectedStartIndex + 1;
                if (targetEndIndex >= size) {
                    targetEndIndex = size;
                }
                $timeEnd.children().eq(targetEndIndex).prop('selected', true);
            }
        };

        if (calendarConfiguration.loginUserType === 'Golf Academy') {
            ApiClient.loadAcademyProList(currentEvent.locationId).done(function (d) {

                var pro = d.data.pros.find(function (pro) {
                    return pro.id === currentEvent.trainerId || pro.id === calendarConfiguration.calendarOwnerId;
                });

                $(d.data.pros)
                    .each(function () {
                        if (!CheckForValidWorkingTimes(this, currentEvent.start, currentEvent.end)) {
                            this.disabled = true;
                        }
                    });

                InitTimeSelection($timeStart, false, pro, currentEvent.start);
                InitTimeSelection($timeEnd, true, pro, currentEvent.start);
                selectCurrentTime();
                updateFunction(true, false);

                var $proSelection = $('#m-modal__pro-selection');

                $proSelection.change(function () {
                    var id = $('#m-modal__pro-selection option:selected').val();
                    var pro = d.data.pros.find(function (pro) {
                        return pro.id === id;
                    });

                    InitTimeSelection($timeStart, false, pro, currentEvent.start, true);
                    InitTimeSelection($timeEnd, true, pro, currentEvent.start, true);
                    updateFunction(true, false);
                });

                if (currentEvent.appointmentType === 'SingleTraining' ||
                    currentEvent.appointmentType === 'Absence') {
                    $proSelection.parents('.m-modal__row').first().hide();
                    $proSelection.prop("disabled", true);
                } else if ($proSelection.length) {
                    $proSelection.parents('.m-modal__row').first().show();

                    var template = Handlebars.partials['academyProList'];
                    $proSelection.append(template({proOptions: d.data.pros}));

                    if ($calendar.fullCalendar('getView').type === 'timelineDay' || calendarConfiguration.calendarType === "Courses") {
                        $proSelection.prop("disabled", false);
                    } else {
                        $proSelection.prop("disabled", true);
                    }

                    if (currentEvent.trainerId) { // academies
                        $proSelection.val(currentEvent.trainerId);
                    } else if (!currentEvent.id &&
                        currentEvent.trainerId &&
                        calendarConfiguration.calendarType !== 'Courses') {
                        $proSelection.prop("disabled", true)
                            .val(calendarConfiguration.calendarOwnerId);
                    } else if ($proSelection.find('option[value="' + calendarConfiguration.calendarOwnerId + '"]').length) {
                        $proSelection.val(calendarConfiguration.calendarOwnerId);
                    } else {
                        // Select no trainer
                        $proSelection.val("");
                    }
                }
            });
        }

        // Populate time span dropdowns, select current option(s)
        InitTimeSelection($timeStart, false);
        InitTimeSelection($timeEnd, true);
        selectCurrentTime();
        updateFunction(true, calendarConfiguration.calendarType === "Appliances");

        // Datepickers in case we have an absence here
        if (isAbsence) {
            $dateStart.datepicker({
                dateFormat: dateTimeFormatString.dateFormatPicker
            }).val(currentEvent.start.format('L'));

            $dateEnd.datepicker({
                dateFormat: dateTimeFormatString.dateFormatPicker
            }).val((currentEvent.end || currentEvent.start).format('L'));
        }

        // Free appointment types
        var updatePriceDisplay = function () {
            if (currentEvent.previousPrice === currentEvent.price) {
                return;
            }
            currentEvent.previousPrice = currentEvent.price;

            if (calendarConfiguration.loginUserType === "Me" || calendarConfiguration.loginUserType === "Anonymous") {
                var isFree = currentEvent.price === 0;
                console.info("Got here. Expecting 1, false, undefined", $typeSelection.length, $typeSelection.is(":disabled"), $typeSelection.val());
                if ($typeSelection.length && !$typeSelection.is(":disabled") && !$typeSelection.val()) {
                    isFree = false;
                } else if (ctx.model.o.isFlatrate) {
                    isFree = false; // Checking for a valid flatrate is performed at a different location
                }
                $('.m-modal__appointment__payment-options.free-display').css("display", isFree ? "block" : "none");
                $('.m-modal__appointment__payment-options.option-selection').css("display", isFree ? "none" : "block");
            }
        };
        updatePriceDisplay();

        // Bind all required events
        $typeSelection.on("change", function () {
            // If user is me Selected Product should be visible in Title-Field and input must be disabled
            if (calendarConfiguration.loginUserType === "Me" || calendarConfiguration.loginUserType === "Anonymous") {
                $this = $(this);
                var chosenElement = calendarConfiguration.appointmentTypes.filter(function (element) {
                    return element.id === $this.val();
                });
                if (chosenElement.length === 1) {
                    $titleField.val(chosenElement[0].title);
                    $titleField.attr("disabled", "disabled");
                }
            }
            // When changing the price, we of course want the price field to update
            updateFunction(true, true);
            updatePriceDisplay();
        });

        var $editSeries = $('#m-modal__input--edit-series');
        var $editSeriesWithAddedParticipants = $("#m-modal__input--edit-series-with-added-participants");
        var $editSeriesWithDeletedParticipants = $("#m-modal__input--edit-series-with-deleted-participants");
        if ($editSeries) {
            $editSeries.prop('checked', currentEvent.editSeries);

            if (currentEvent.editSeries === true) {
                $editSeriesWithAddedParticipants.parents('.m-modal__row').first().show();
                $editSeriesWithAddedParticipants.prop('checked', currentEvent.editSeriesWithAddedParticipants);
                $editSeriesWithDeletedParticipants.parents('.m-modal__row').first().show();
                $editSeriesWithDeletedParticipants.prop('checked', currentEvent.editSeriesWithDeletedParticipants);
            } else {
                $editSeriesWithAddedParticipants.parents('.m-modal__row').first().hide();
                $editSeriesWithAddedParticipants.prop("checked", false);
                $editSeriesWithDeletedParticipants.parents('.m-modal__row').first().hide();
                $editSeriesWithDeletedParticipants.prop("checked", false);
            }

            $editSeries.on("change", function () {
                if ($editSeries.is(':checked')) {
                    $editSeriesWithAddedParticipants.parents('.m-modal__row').first().show();
                    $editSeriesWithDeletedParticipants.parents('.m-modal__row').first().show();
                } else {
                    $editSeriesWithAddedParticipants.parents('.m-modal__row').first().hide();
                    $editSeriesWithAddedParticipants.prop("checked", false);
                    $editSeriesWithDeletedParticipants.parents('.m-modal__row').first().hide();
                    $editSeriesWithDeletedParticipants.prop("checked", false);
                }
            });
        }

        var updatePriceAllowed = (!ctx.model.o || !ctx.model.o.id) && !currentEvent.price;
        var updateEndAllowed = !ctx.model.o || !ctx.model.o.id;
        updateFunction(updateEndAllowed, updatePriceAllowed);

        // Disable components in case of me
        if (calendarConfiguration.loginUserType === "Me" || calendarConfiguration.loginUserType === "Anonymous") {
            $titleField.prop('readonly', !!currentEvent.appointmentId);
            $descriptionField.prop('readonly', !!currentEvent.appointmentId);

            if (currentEvent.appointmentType === 'Package') {
                $coursePackDescriptionField.prop('readonly', !!currentEvent.appointmentId);
            }

            ctx.isParticipant = false;
            ctx.canParticipate = currentEvent.participantsCount + 1 <= currentEvent.maxParticipants;
            if (currentEvent.participants && currentEvent.participants.length) {
                var myParticipant = currentEvent.participants.find(function (p) {
                    return p.userId === calendarConfiguration.loginUserId;
                });
                if (myParticipant) {
                    ctx.canParticipate = myParticipant.paymentStatus === "Unpaid"
                        || myParticipant.paymentStatus === "PaymentPendingStripe"
                        || myParticipant.paymentStatus === "PaymentPendingPrepaidCard";
                    ctx.isParticipant = true;
                }
            }

            $paymentRadioButton.prop('disabled', !(!currentEvent.id || ctx.canParticipate));

            if (ctx.canParticipate && ctx.model.o.isFlatrate) {
                ApiClient.isFlatrateValidForOccurrence(ctx.model.o).done(function (d) {
                    if (d) {
                        if (d.data === "valid") {
                            // Render the flatrate checkbox.
                            var $options = ctx.$el.find('.m-modal__appointment__payment-options.option-selection');
                            $options.html(Handlebars.helpers.checkbox('paymentType', '', 'flatrate', $t('Flatrate'), true));
                            $options.css("display", "block");
                            $('.m-modal__appointment__payment-options.free-display').css("display", "none");
                            // Set participation possible and re-render the buttons.
                            ctx.canParticipate = true;
                            _prepareButtons(ctx.stepConfiguration, ctx);
                        } else {
                            if (d.error && d.error.message) {
                                $('#payment-flatrate-message').text(d.error.message);
                            }
                        }
                    } else {
                        $('#payment-flatrate-message').text('An unknown error occured while checking for a valid flatrate.');
                    }
                }).fail(function () {
                    ShowErrorPanel('An unknown error occured while checking for a valid flatrate.');
                });
            }

            // Disable participation if no payment options are available.
            ctx.canParticipate = ctx.canParticipate && ctx.model.paymentOptions.length;
        }

        if (calendarConfiguration.loginUserType === "Me" || calendarConfiguration.loginUserType === "Anonymous") {
            var $paymentTypeButtons = $("input[name='paymentType']");
            if ($paymentTypeButtons.length && $paymentTypeButtons.filter(function () { return this.value === "onlinepaymentdisabled"; }).length > 0) {
                $paymentTypeButtons.change(function () {
                    var $errorText = $(".m-modal__appointment__payment-options.error-text");
                    var $saveButton = $("#m-modal__btn-save");

                    if (this.value === "onlinepaymentdisabled") {
                        $errorText.show();
                        $saveButton[0].disabled = true;
                    } else {
                        $errorText.hide();
                        $saveButton[0].disabled = false;
                    }
                });
            }
        }

        // Prefer online payment if available, otherwise select first payment method.
        // Changed requirement as of 2023-04-25
        if (calendarConfiguration.loginUserType === "Me" || calendarConfiguration.loginUserType === "Anonymous") {
            $(document).ready(function () {
                var $stripeButton = $paymentRadioButton.filter("[value='stripe']");
                var $onlinepaymentdisabledButton = $paymentRadioButton.filter("[value='onlinepaymentdisabled']");
                if ($stripeButton.length) {
                    $stripeButton.prop("checked", true);
                } else if ($onlinepaymentdisabledButton.length) {
                    $onlinepaymentdisabledButton.prop("checked", true);
                    $paymentRadioButton.trigger("change");
                } else {
                    $paymentRadioButton.first().prop('checked', true);
                }


                var $sendMessageButton = $(".m-modal__appointment__payment-options.send-message");

                if ($sendMessageButton.length) {
                    $sendMessageButton.css("cursor", "pointer");
                    $sendMessageButton.css("color", "#547e00");
                    $sendMessageButton.on("click", function () {
                        var message = $sendMessageButton.attr('data-message').replace("<ME-Name>", ctx.model.calendarConfiguration.loginUserName);
                        message += " " + window.location.protocol + '//' + window.location.host.substring(9) + "/Account#paymentOptions";
                        parent.postMessage(JSON.stringify({
                            "action": "sendNewMessage",
                            "id": ctx.model.calendarConfiguration.calendarOwnerId.split(","),
                            "message": message,
                        }), "*");
                    });
                }
            });
        }

        $primaryMenuBar.show();
        if (calendarConfiguration.loginUserType.toLowerCase() === "me" && currentEvent.appointmentType === "Absence") {
            $datapicker.prop('disabled', true);
            $paymentRadioButton.prop('disabled', true);
            $primaryMenuBar.hide();
        }

        ctx.$el.find('.m-modal__appointment__button--text-template')
            .on('click',
                function () {
                    OpenModal('chooseTextTemplate');
                });

        var $isFlatrate = $("input[name='isFlatrate']");
        var $isPublic = $("input[name='isPublic']");
        var $isNotBookable = $("input[name='isNotBookable']");
        var flatrateCheckedInitially = $isFlatrate.is(':checked');
        var publicCheckedInitially = $isPublic.is(':checked');
        var notBookableCheckedInitially = $isNotBookable.is(':checked');

        $isFlatrate.on('change',
            function () {
                if (this.checked) {
                    $isFlatrate.parents('label').first().removeClass('c-checkbox--disabled');

                    $isPublic.prop('checked', false).parents('label').first().addClass('c-checkbox--disabled');
                    $isNotBookable.prop('checked', true).parents('label').first().addClass('c-checkbox--disabled');
                } else {
                    $isPublic.prop('checked', false).parents('label').first().removeClass('c-checkbox--disabled');
                    $isNotBookable.prop('checked', false).parents('label').first().removeClass('c-checkbox--disabled');
                }
            });

        $isPublic.on('change',
            function () {
                if (this.checked) {
                    $isPublic.parents('label').first().removeClass('c-checkbox--disabled');
                    $isNotBookable.parents('label').first().removeClass('c-checkbox--disabled');

                    if ($isFlatrate.is(':checked')) {
                        $isFlatrate.prop('checked', false).parents('label').first().addClass('c-checkbox--disabled');
                        $isNotBookable.prop('checked', false);
                    }
                } else {
                    $isFlatrate.prop('checked', false).parents('label').first().removeClass('c-checkbox--disabled');
                    $isNotBookable.prop('checked', false).parents('label').first().removeClass('c-checkbox--disabled');
                }
            });

        $isNotBookable.on('change',
            function () {
                if (this.checked) {
                    $isPublic.parents('label').first().removeClass('c-checkbox--disabled');
                    $isNotBookable.parents('label').first().removeClass('c-checkbox--disabled');

                    $isFlatrate.prop('checked', false).parents('label').first().addClass('c-checkbox--disabled');
                    $isPublic.prop('checked', true).parents('label').first().removeClass('c-checkbox--disabled');
                } else {
                    if (!$isPublic.is(':checked')) {
                        $isFlatrate.prop('checked', false).parents('label').first().removeClass('c-checkbox--disabled');
                    }
                }
            });

        if (publicCheckedInitially) {
            $isPublic.prop('checked', true);
            $isPublic.trigger('change');
        }

        if (notBookableCheckedInitially) {
            $isNotBookable.prop('checked', true);
            $isNotBookable.trigger('change');
        }

        if (flatrateCheckedInitially) {
            $isFlatrate.prop('checked', true);
            $isFlatrate.trigger('change');
        }
    },
    validate: function (action) {
        if (action && (action === "whiteLabelLogin" || action === "whiteLabelRegister")) {
            return true;
        }

        if (calendarConfiguration.loginUserType === "Anonymous" && currentEvent.price === 0) {
            ShowErrorPanel($t("Loggen Sie sich ein, um dieses kostenlose Angebot anzunehmen"));
            return false;
        }
        return true;
    },
    save: function () {

        var templateSel = document.getElementById("m-modal__appointment-type");
        if (templateSel)
            currentEvent.templateId = templateSel.value;

        var subjectSel = document.getElementById("m-modal__appointment-subject");
        if (subjectSel)
            currentEvent.subjectId = subjectSel.value;

        var price = document.getElementById("m-modal__price-panel");

        if (calendarConfiguration.loginUserType !== "Me") {
            if (price) {
                var replacement = parseFloat(price.value);
                if (!isNaN(replacement)) {
                    currentEvent.price = replacement;
                }
            }
        }

        var paymentMethod = $("input[name='paymentType']:checked").val();
        if (paymentMethod)
            currentEvent.paymentMethod = paymentMethod;

        var $proSelection = $("#m-modal__pro-selection");
        if ($proSelection.length && $proSelection.is(':visible')) {
            currentEvent.trainerId = $proSelection.val() || null;
        }

        var isFlatrate = $("input[name='isFlatrate']");
        currentEvent.isFlatrate = isFlatrate.is(':checked');

        var isPublic = $("input[name='isPublic']");
        if (isPublic.length) {
            currentEvent.isPublic = isPublic.is(':checked');
        }

        var marketingPageNone = $("#marketingPage_none");
        if (marketingPageNone.length) {
            var marketingPageView = $("#marketingPage_view");
            var marketingPageBook = $("#marketingPage_book");

            currentEvent.isPublic = marketingPageView.is(":checked") || marketingPageBook.is(":checked");
            currentEvent.isNotBookable = !marketingPageBook.is(":checked");
        }

        currentEvent.title = $("#m-modal__input-appointment-title").val();
        currentEvent.databaseTitle = currentEvent.title;

        currentEvent.description = $("#m-modal__textarea-appointment-description").val();

        if (currentEvent.appointmentType === 'Package') {
            currentEvent.coursePackDescription = $("#m-modal__textarea-appointment-coursePack-description").val();
        }

        var $startDate = $("input[name='dateFrom']");
        var $endDate = $("input[name='dateTo']");

        var startDateMoment = moment($startDate.val() || currentEvent.start.format(dateTimeFormatString.dateFormat), dateTimeFormatString.dateFormat);
        var endDateMoment = moment($endDate.val() || currentEvent.start.format(dateTimeFormatString.dateFormat), dateTimeFormatString.dateFormat);

        var startDate = (startDateMoment.format('YYYY-MM-DD')) + "T" + $("#time-start").val();
        var endDate = (endDateMoment.format('YYYY-MM-DD')) + "T" + $("#time-end").val();

        if (!currentEvent.occurences || !currentEvent.occurences.length) {
            currentEvent.occurences = [{
                startDate: startDate,
                endDate: endDate,
                description: currentEvent.description
            }];
        }

        var currentOccurrenceIdx = -1;
        for (var i = 0; i < currentEvent.occurences.length; ++i) {
            var currentOcc = currentEvent.occurences[i];
            if (currentOcc.id === currentEvent.id) {
                currentOccurrenceIdx = i;
                break;
            }
        }

        if (currentOccurrenceIdx === -1) {
            if (calendarConfiguration.loginUserType === "Me") {
                return;
            }

            throw "unable to find occurrence in occurrences list.";
        }

        var currentOccurrence = currentEvent.occurences[currentOccurrenceIdx];

        currentOccurrence.startDate = startDate;
        currentOccurrence.endDate = endDate;
        currentOccurrence.description = currentEvent.description;

        $editSeries = $('#m-modal__input--edit-series');
        $editSeriesWithAddedParticipants = $("#m-modal__input--edit-series-with-added-participants");
        $editSeriesWithDeletedParticipants = $("#m-modal__input--edit-series-with-deleted-participants");

        if ($editSeries) {
            if ($editSeries.is(':checked')) {
                currentEvent.editSeries = true;
            } else {
                currentEvent.editSeries = false;
            }
        }
        if ($editSeriesWithAddedParticipants) {
            if ($editSeriesWithAddedParticipants.is(':checked')) {
                currentEvent.editSeriesWithAddedParticipants = true;
            } else {
                currentEvent.editSeriesWithAddedParticipants = false;
            }
        }
        if ($editSeriesWithDeletedParticipants) {
            if ($editSeriesWithDeletedParticipants.is(':checked')) {
                currentEvent.editSeriesWithDeletedParticipants = true;
            } else {
                currentEvent.editSeriesWithDeletedParticipants = false;
            }
        }
    },
    cancel: function () {
        return true;
    },
    getButtonList: function (ctx) {
        if (calendarConfiguration.loginUserType === "Anonymous") {
            // Anonymous can only save if online payment is present
            return {
                "save": ctx.model.paymentOptions && ctx.model.paymentOptions.length,
                "whiteLabelSave": true, // Just for different text on save button
                "whiteLabelLogin": true,
                "whiteLabelRegister": true,
                "cancel": !!currentEvent.id && ctx.isParticipant
            }
        }

        var showAddRoom = !currentEvent.id && calendarConfiguration.calendarType !== "Appliances" && currentEvent.appointmentType === "SingleTraining";
        if (calendarConfiguration.loginUserType === "Me") {
            // Mes can only save, or book a room for new appointments
            return {
                "save": !currentEvent.id || ctx.canParticipate,
                "cancel": !!currentEvent.id && ctx.isParticipant,
                "addRoom": showAddRoom
            };
        }

        return {
            "next": currentEvent.appointmentType === 'Package' ? 'packageDates' : currentEvent.appointmentType !== "Absence" ? "participants" : false,
            "back": true,
            "save": currentEvent.appointmentType !== "SingleTraining", // Single trainings require exactly one participant
            "cancel": !!currentEvent.id,
            "cancelSeries": currentEvent.isSeries,
            "series": calendarConfiguration.loginUserType !== "Me" && currentEvent.appointmentType === "Absence" && !currentEvent.id,
            "cancelPackage": currentEvent.appointmentType === 'Package',
            "addRoom": showAddRoom
        };
    }
};
